export enum IdStatusAgendamento {
    EmAndamento = 1,
    Protocolado = 2,
    Inativo = 11,
}
